import React from 'react';
import { ModalHeader, ModalBody, ModalFooter } from './Components';
import { closeModal } from './Utils';
import styled from "styled-components";

const ModalContent = styled.div`
  &.mdn-Modal--sm {
    .mdn-Modal-content {
      height: auto !important;
    }
  }
`;

const MondrianModal = ({ content, ...props }) => {
  const modalContent = content?.info || content?.warning;
  if (!modalContent) return null;
  const { disableCloseButton, disableFooterButton } = modalContent;
  const { title, message, instructions, buttons } = modalContent;

  return (
    <div>
      {!!message && (
        <ModalContent className="mdn-Modal mdn-Modal--sm mdn-isOpen">
          <div className="mdn-Modal-content">
            <ModalHeader title={title} closeModal={closeModal} disableCloseButton={disableCloseButton} props={props} />
            <div className="mdn-Divider mdn-Divider--default"></div>
            <ModalBody message={message} instructions={instructions} />
            <ModalFooter
              buttons={buttons}
              disableCloseButton={disableCloseButton}
              disableFooterButton={disableFooterButton}
              closeModal={closeModal}
              props={props}
            />
          </div>
        </ModalContent>
      )}
    </div>
  );
};

export default MondrianModal;
